import { Grid, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import {
    getProjects,
    getTicket,
    createTicket,
    updateTicket,
    getLoginUser,
    getComments,
    updateComments,
} from "../../actions/GenomicsResearchAction";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);
interface Props {
    getProjects: any;
    projects: any;
    getTicket: any;
    fetchTickets: any;
    createTicket: any;
    updateTicket: any;
    getLoginUser: any;
    fetchLoginUser: any;
    getComments: any;
    fectchComments: any;
    updateComments: any;
    loading: boolean;


}
const StopsPlace: React.FC<Props> = ({
    getProjects,
    projects,
    getTicket,
    fetchTickets,
    createTicket,
    updateTicket,
    getLoginUser,
    fetchLoginUser,
    getComments,
    fectchComments,
    updateComments,
    loading,

}) => {
    const history = useHistory();
    const [subject, setSubjet] = React.useState<any>("");
    const [docContact, setDocContact] = useState<any>("")
    const [isEdit, setIsEdit] = useState<any>(false);
    const [type, setType] = useState<any>("");
    const [project, setProject] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const timer = useRef<any>(0);
    const [description, setDescription] = useState<any>("");
    const [assignTo, setAssignTo] = useState<any>([]);
    const [assignName, setAssignName] = useState<any>([]);
    const [displayProject, setDisplayProject] = useState<any>("");
    const [comment, setComment] = useState<any>("");
    const [Id, setId] = useState<any>("")
    const classes = useStyles();
    const [mobileValidation, setMobileValidation] = useState({
        docContact: true,
    });
    const verifyMobile = (type: any) => {
        if (type === "mobile") {
            if (
                parseInt(docContact && docContact[0]) < 6 ||
                (docContact && docContact.length < 10)
            ) {
                setMobileValidation((prev: any) => ({
                    ...prev,
                    docContact: false,
                }));
            }
        }
    }

    const handleTicketdata = async (e: any) => {
        e.preventDefault();
        const ticketData = {
            subject,
            type,
            description,
            project,
            assignTo,
        };
        const ticketDataEdit = {
            subject,
            type,
            description,
            project,
            assignTo,
        };
        if (project === "" || project === "none") {
            delete ticketData.project;
        }
        if (isEdit) {
            await updateTicket(ticketDataEdit, id);
        } else {
            await createTicket(ticketData);
        }
        history.push(`/dashboard/gnre/samaadhan_itrack`);
    };

    const handleComment = async (e: any) => {
        e.preventDefault();
        const ticketComment = {
            comment,
            ticketId: Id,
        }
        await updateComments(ticketComment);
        getComments(`?ticketId=${id}`)
        setComment("");
    };

    useEffect(() => {
        getProjects();
        getLoginUser();
    }, [])

    useEffect(() => {
        if (id && id !== 'create') {
            getTicket(`${id}`);
            getComments(`?ticketId=${id}`)
        }
    }, [])

    useEffect(() => {
        if (fetchTickets && id !== 'create') {
            const list = fetchTickets;
            setDescription(list?.description);
            setSubjet(list?.subject);
            setDisplayProject(list?.project?.projectId);
            setType(list?.type);
            setId(list?._id);
            setAssignName(list?.assignTo);
            setProject(list?.project?._id);
            setAssignTo(list?.assignTo && list?.assignTo?.length > 0 && list?.assignTo?.map((val: any) => val?.id || ""));
            setIsEdit(true);
        }
    }, [fetchTickets])

    return (
        <Grid container spacing={2}>
            <form style={{ width: "100%" }} onSubmit={handleTicketdata}>
                <Paper style={{ margin: "70px auto", width: "80%", marginTop: 70 }}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Samaadhan Desk</h2>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <Autocomplete
                                id="Project_id"
                                onChange={(event, newValue) => {
                                    setProject(newValue?._id);
                                }}
                                defaultValue={projects?.projectId}
                                options={projects?.results || []}
                                inputValue={displayProject}
                                blurOnSelect
                                disabled={isEdit === true}
                                getOptionLabel={(option: any) => {
                                    return (
                                        (option?.projectId) +
                                        " " +
                                        (option?.institute?.name || "") +
                                        " " +
                                        (option?.scientist?.name || "") +
                                        "," +
                                        (option?.dealer?.firmName || "")
                                    );
                                }}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getProjects(`?search=${newInputValue}`);
                                    }, 1000);
                                    setDisplayProject(newInputValue)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Project Id"
                                        placeholder="Search ID/Client/Dealer Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                key={isEdit}
                                className="input"
                                label="Subject"
                                fullWidth
                                variant="outlined"
                                value={subject}
                                disabled={isEdit === true}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setSubjet(e.target.value)}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Select
                                className="input"
                                label="Ticket Handling"
                                fullWidth
                                variant="outlined"
                                value={type || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setType(e.target.value)}
                            >
                                <MenuItem value="none" disabled>Select Type</MenuItem>
                                <MenuItem value={"Response to Client"}>Response to Client</MenuItem>
                                <MenuItem value={"Analysis Status"}>Analysis Status</MenuItem>
                                <MenuItem value={"Wetlab Status"}>Wetlab Status</MenuItem>
                                <MenuItem value={"Shipment"}>Shipment</MenuItem>
                                <MenuItem value={"Pickup"}>Pickup</MenuItem>
                                <MenuItem value={"Logistics"}>Logistics</MenuItem>
                                <MenuItem value={"Quotation"}>Quotation</MenuItem>
                                <MenuItem value={"Invoicing/Payment"}>Invoicing/Payment</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Autocomplete
                                key={subject}
                                id="AssignTo"
                                multiple
                                limitTags={1}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        let sourceIds: any = [];
                                        newValue.map((val: any) => {
                                            let obj = JSON.parse(JSON.stringify(val, null, " "));
                                            sourceIds.push(obj.id);
                                        });
                                        setAssignTo(sourceIds);
                                    }
                                }}
                                defaultValue={assignName || []}
                                disableCloseOnSelect
                                options={fetchLoginUser || []}
                                getOptionLabel={(option: any) =>
                                    option?.fullname
                                }
                                freeSolo
                                // onInputChange={(event, newInputValue) => {

                                //     clearTimeout(timer.current);
                                //     timer.current = setTimeout(() => {
                                //         getLoginUser(
                                //             `${newInputValue}`
                                //         );
                                //     }, 1000);
                                // }}
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        placeholder="Select Assign To"
                                        label="Assign To"
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "1px" }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextareaAutosize
                                aria-label="Description "
                                minRows={3}
                                value={description}
                                disabled={isEdit === true}
                                onChange={(e) => setDescription(e.target.value as string)}
                                placeholder="Description"
                                style={{ width: "100%", height: "50px" }}
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            type="submit"
                            style={{ width: 300 }}
                        >
                            {isEdit ? "update" : "Create"}
                        </Button>
                    </Grid>
                    {isEdit === true ?
                        <>
                            <div >
                                <h6
                                    style={{
                                        marginBottom: "10px",
                                        textAlign: "center",
                                        borderBottom: "1px solid rgba(0,0,0,0.5)",
                                    }}
                                    id="transition-modal-title"
                                >
                                    Reply History
                                </h6>
                                <div
                                    id="transition-modal-description"
                                    className="modal-form-wrapper"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                    }}
                                >
                                    <div className="comment-history">
                                        {loading
                                            ? "Please Wait"
                                            : Object.keys(fectchComments).length > 0
                                                ? fectchComments?.results?.map((comment: any) => (
                                                    <p>
                                                        {comment.createdAt.substring(0, 10)} :{" "}
                                                        {comment.createdAt.substring(11, 16)} :{" "}
                                                        {comment?.createdBy?.username} : {comment.comment}:{" "}

                                                    </p>
                                                ))
                                                : ""}
                                    </div>
                                </div>
                            </div>

                            <Grid xs={12}>
                                <TextareaAutosize
                                    aria-label="Reply"
                                    minRows={3}
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value as string)}
                                    placeholder="Reply"
                                    style={{ width: "100%", height: "40px" }}
                                />
                            </Grid>
                            <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                    style={{ width: 300,backgroundColor:"#1f823d" }}
                                    onClick={handleComment}
                                >
                                    Reply
                                </Button>
                            </Grid>
                        </>
                        : ""}
                </Paper>
            </form>
        </Grid >
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsCAReducer.projects,
    fetchTickets: state.GenomicsCAReducer.fetchTickets,
    fetchLoginUser: state.GenomicsCAReducer.fetchLoginUser,
    fectchComments: state.GenomicsCAReducer.fectchComments,
});
export default connect(mapStateToProps, {
    getProjects,
    getTicket,
    createTicket,
    updateTicket,
    getLoginUser,
    getComments,
    updateComments,
})(StopsPlace);
